<template>
  <div class="view__card" v-loading="loading">
    <List
      v-model="query"
      :filter="filter"
      :columns="columns"
      :tableData="tableData"
      showSelection
    >
      <template v-slot:slot_type="{ row }">
        <span>{{ row.type ? '科室' : '医院' }}</span>
      </template>

      <template v-slot:slot_recommend="{ row }">
        <el-switch
          v-model="row.recommend"
          :active-value="true"
          :inactive-value="false"
          @change="setRecommend(row.id, row.recommend)"
          active-text=""
          inactive-text=""
          :width="50"
          class="textSwitch"
        >
        </el-switch>
      </template>
      <template v-slot:slot_state="{ row }">
        <el-switch
          v-model="row.state"
          :active-value="true"
          :inactive-value="false"
          @change="setState(row.id, row.state)"
          active-text=""
          inactive-text=""
          :width="50"
          class="textSwitch"
        >
        </el-switch>
      </template>
      <template v-slot:slot_seqIndex="{ row }">
        <EditableText
          icon="el-icon-edit"
          v-model="row.seqIndex"
          @confirm="confirmEdit($event, row.id)"
          @cancel="cancel"
        ></EditableText>
      </template>
      <template v-slot:fixed="{ row }">
        <el-button type="text" @click="info(row.id)"> 详情 </el-button>
        <el-button type="text" @click="edit(row.id)"> 编辑 </el-button>
        <el-button type="text" @click="del(row.id)"> 删除 </el-button>
        <el-button slot="reference" type="text" @click="share(row)"
          >分享</el-button
        >
      </template>
      <template v-slot:footertool>
        <el-button plain type="primary" @click="handleCommand('del')">
          批量删除
        </el-button>
        <el-button plain type="primary" @click="handleCommand('recommend')">
          批量推荐
        </el-button>
        <el-button
          plain
          type="primary"
          @click="handleCommand('cancelRecommend')"
        >
          批量取消推荐
        </el-button>
        <el-button type="primary" @click="addArticle">
          新增文章
        </el-button>
      </template>
    </List>
    <!--分享-->
    <ShareEq :id="rowData.id" :title="rowData.title" ref="share"></ShareEq>
  </div>
</template>
<script>
/**
 * @author xingzhesun
 * @name   articleList
 * @desc   健康管理-咨询-文章管理列表
 * @props  none
 * @emit   none
 */
import { List, mixin, EditableText } from '@/components'
import ShareEq from '../components/shareEq'
import {
  dataList,
  isRecommendArticle,
  isStateArticle,
  sortSeqIndex,
  delArticle,
  columnList,
  batchDelArticle,
  batchRecommendArticle,
  batchCancelRecommendArticle,
} from '@/api/healthApi/articleSet'

export default {
  components: {
    List,
    EditableText,
    ShareEq,
  },
  mixins: [
    mixin([
      {
        fetchListFunction: async params => {
          !params.columnId && delete params.columnId
          return await dataList(params)
        },
      },
    ]),
  ],
  data() {
    return {
      dialogVisible: false,
      optionsList: [],
      query: {
        timeType: 0,
        searchType: 0,
        pageSize: 10,
        currentNum: 1,
        field: 'create_time',
        sorted: 'DESC',
      },
      columns: {
        index: {
          hidden: true,
        },
        op: {
          hidden: true,
        },
        orgName: {
          label: '应用范围',
          formatter: row => {
            return row.orgId == 'ZY' ? '住院' : '门诊'
          },
        },
        type: {
          prop: 'slot_type',
          hidden: true,
        },
        createTime: {
          minWidth: 160,
        },
        recommend: {
          prop: 'slot_recommend',
        },
        state: {
          prop: 'slot_state',
        },
        fixed: {
          width: 190,
        },
        seqIndex: {
          prop: 'slot_seqIndex',
          minWidth: 120,
        },
      },
      rowData: {},
    }
  },
  created() {
    this.getColumnList()
  },
  methods: {
    share(row) {
      this.rowData = row
      this.$refs.share.isOpen()
    },

    async getColumnList() {
      const res = await columnList()
      const newArr = res.map(item => {
        return { label: item.name, value: item.id }
      })
      this.optionsList = [{ label: '不限', value: '' }, ...newArr]
    },
    info(articleId) {
      this.$router.push(
        `/information/article/articleInfo?articleId=${articleId}`,
      )
    },
    edit(articleId) {
      this.$router.push(
        `/information/article/editArticle?articleId=${articleId}`,
      )
    },
    del(articleId) {
      this.$confirm('是否确认删除？', '提示', {
        type: 'warning',
      }).then(async () => {
        await delArticle({ articleId })
        this.$message.success('删除成功！')
        this.$_fetchTableData()
      })
    },
    handleCommand(type) {
      if (this.tableData.multipleSelection.length < 1) {
        this.$message({
          type: 'warning',
          message: '请先勾选需要处理的数据',
          showClose: true,
        })
        return
      }
      const types = {
        del: this.batchDel,
        recommend: this.batchRecommend,
        cancelRecommend: this.batcCancelRecommend,
      }
      const titles = {
        del: '批量删除',
        recommend: '批量推荐',
        cancelRecommend: '批量取消推荐',
      }
      const articles = this.tableData.multipleSelection.map(item => {
        return item.id
      })
      this.$confirm(`是否${titles[type]}选中项？`, '提示', {
        type: 'warning',
      }).then(() => {
        return types[type](articles)
      })
    },

    addArticle() {
      this.$router.push('/information/article/addArticle')
    },
    //切换推荐
    async setRecommend(articleId) {
      await isRecommendArticle({ articleId })
      this.$message.success('操作成功！')
    },
    //切换文章状态
    async setState(articleId) {
      await isStateArticle({ articleId })
      this.$message.success('操作成功！')
    },
    //确认编辑序号
    async confirmEdit(seqIndex, articleId) {
      await sortSeqIndex({ seqIndex, articleId })
      this.$message.success('操作成功！')
      this.$_fetchTableData()
    },
    cancel() {},
    //批量删除
    async batchDel(articles) {
      await batchDelArticle({ articles })
      this.$message.success('操作成功！')
      this.$_fetchTableData()
    },
    //批量推荐
    async batchRecommend(articles) {
      await batchRecommendArticle({ articles })
      this.$message.success('操作成功！')
      this.$_fetchTableData()
    },
    //批量取消推荐
    async batcCancelRecommend(articles) {
      await batchCancelRecommendArticle({ articles })
      this.$message.success('操作成功！')
      this.$_fetchTableData()
    },
  },
  computed: {
    filter() {
      return {
        date: {
          props: {
            options: [{ label: '创建时间', value: 0 }],
          },
          keys: ['timeType', 'startTime', 'endTime'],
        },
        search: {
          props: {
            options: [
              { label: '标题', value: 0 },
              { label: '来源', value: 1 },
            ],
          },
          keys: ['searchType', 'search'],
        },
        popover: [
          {
            props: {
              label: '所属分类',
              options: this.optionsList,
            },
            keys: 'columnId',
          },
          {
            props: {
              label: '推荐',
              options: [
                { label: '不限', value: '' },
                { label: '推荐', value: true },
                { label: '不推荐', value: false },
              ],
            },
            keys: 'recommend',
          },
          {
            props: {
              label: '状态',
              options: [
                { label: '不限', value: '' },
                { label: '显示', value: true },
                { label: '隐藏', value: false },
              ],
            },
            keys: 'state',
          },
        ],
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.dialog-footer {
  text-align: center;
}
</style>
